export default {
  about: {
    XY: 'WEIOT (SRL)',
    aboutUs: 'About us',
    aboutUsText1: 'We specialize in full-scenario IoT applications, integrating R&D, production, and sales. As a high-tech enterprise in the GPS positioning industry, our vision is to "become a leading IoT service provider." Our business covers digital logistics, parking space digitization, pet tracking digitization, and portable locators. Our smart mobile products are widely used in cargo tracking, theft prevention for valuable equipment, personnel safety management, pet/child/elderly anti-loss, and more. These products enable remote management of critical assets, improving operational efficiency, ensuring safety, reducing costs, and enhancing service capabilities.',
    aboutUsText2: "WEIOT focuses on products and connects with customers in all aspects from planning, development, production, delivery, and after-sales, providing complete and comprehensive services for the entire life cycle of customers' products. In the early stage of the project, we fully understand the customer's product needs, focus on the market, and determine the product design direction. At the same time, WEIOT relies on strategic partners with strong R&D capabilities and has build a solid supply chain to shorten the mass production and ole-out. Through dedication and emphasis on quality, WEIOT provids the most effective and professional support for a wide arraz of applications.",
    reasonsTitle:'Why choose us',
    reasonsItemTitle1:'Precision Positioning',
    reasonsItemText1:'Advanced R&D ensures industry-leading accuracy.',
    reasonsItemTitle2:'Diverse Product Line',
    reasonsItemText2:'Solutions for individuals, families, and enterprises.',
    reasonsItemTitle3:'Comprehensive Security',
    reasonsItemText3:'Data encryption and strict privacy policies.',
    reasonsItemTitle4:'Professional after-sales team',
    reasonsItemText4:'24/7 support with dedicated teams.',
    teamTitle:'Our team',
    teamItemTitle1:'Product Department',
    teamItemText1:'We are well aware of the market trends and focus on translating customer needs into innovative and practical products to ensure that every product meets your expectations.',
    teamItemTitle2:'R&D Department',
    teamItemText2:'With strong technical strength and innovation capabilities, we are committed to creating high-quality, high-performance products and platforms for you, and providing you with continuous technical support and guarantees.',
    teamItemTitle3:'Business Department',
    teamItemText3:'We are proficient in market strategies and can accurately grasp business opportunities. We can tailor cooperation plans for you to ensure that your investment returns are maximized.',
    teamItemTitle4:'Product Marketing Department',
    teamItemText4:'With keen market insight and professional marketing strategies, we ensure that our products are always at the forefront of the market and provide strong support for your business growth.',
    teamItemTitle5:'After-sales Department',
    teamItemText5:'Our professional after-sales team is always customer-centric, providing timely, efficient and comprehensive technical support and services to ensure you have a worry-free experience when using our products.',
    dreamText1:'Driven by Your Dreams',
    dreamText2:'Delivering Technology and Quality Products Globally',
    honorTitle:'Certifications & Honors'
  },
  connection:{
    contactUs:'Contact Us',
    contactUsItemTitle1:'Headquarters',
    contactUsItemText1:'Building 10, No. 55, Zidong Road, Maqiao Town, Minhang District, Shanghai (Liandong U Valley Artificial Intelligence Science and Technology Park)',
    contactUsItemTitle2:'Branch',
    contactUsItemText2:'Address: Rue Colonel Bourg 127, 1140 Evere, Belgium.',
    contactUsItemTitle3:'Telephone',
    contactUsItemText3:'400-626-5529',
    contactUsItemTitle4:'Email',
    contactUsItemText4:'Email: info@weiotglobal.com',
  },
  home:{
    xyLocator:'Smart Locator',
    locatorText:'Anytime, Anywhere, Traceable',
    vehicleTex3:'Control Every Journey, Smarter and Safer',
    partnerText:'Our products have won the trust and support of many customers. We will continue to develop and maintain more high-quality customers and provide professional product service support',
    productSeries:'Product Series',
    technicalExperience:'Technical Expertise',
    researchAndDevelopmentCenter:'R&D Center',
    cooperativeClient:'Cooperative Clients',
    year:'Year',
    xyTechnology:'Weiot Technology',
    viewMore:'View More',
    worryFreePositioning:'Worry-Free Positioning, Precision Every Moment',
    aboutLargeText:`We specialize in full-scenario IoT applications, integrating R&D, production, and sales. As a high-tech enterprise in the GPS positioning industry, our vision is to "become a leading IoT service provider." Our business covers digital logistics, parking space digitization, pet tracking digitization, and portable locators. Our smart mobile products are widely used in cargo tracking, theft prevention for valuable equipment, personnel safety management, pet/child/elderly anti-loss, and more. These products enable remote management of critical assets, improving operational efficiency, ensuring safety, reducing costs, and enhancing service capabilities.`,
    productsTitle:'Main Products',
    productText:'Different Positioning Products for Your Applications',
    productBlueTooth:'Bluetooth Beacon',
    solutionsTitle:'Solutions',
    solutionsItemTitle1:'Digital Solutions for Circular Packaging',
    solutionsItemText1:'Combining digital applications and IoT technology, we build a smart digital platform based on circular carriers—"standardization + intelligence + internetization." This gives carriers a digital life, making them traceable, visible, manageable, and accountable.',
    solutionsItemTitle2:'Vehicle Positioning Solutions',
    solutionsItemText2:'A comprehensive solution based on modern information technology, integrating IoT, big data, and cloud computing. Positioning products transmit vehicle data in real-time to the backend management system via 4G/5G networks. The platform provides real-time insights into vehicle location, speed, stops, and more, offering strong support for vehicle dispatch, route planning, fault warnings, and management.',
    partnersTitle:'They Have Chosen WEIOT',
    partnersText:'Our products have earned the trust and support of many international clients. We will continue to develop and maintain ever more efficient products while providing professional service support.',
    footerText1:'Address: Rue Colonel Bourg 127, 1140 Evere, Belgium',
    footerText2:'Branch: Rue Colonel Bourg 127, 1140 Evere, Belgium',
    footerText3:'Email: info@weiotglobal.com',
    wxErcode:'WeChat Official Account'
  },
  navigation:{
    index:'Front Page',
    productCenter:'Product Center',
    solution:'Solutions',
    digitalSolutionsForCircularPackaging:'Digital Solutions for Circular Packaging',
    digitalSolutionForVehiclePositioning:'Digital Vehicle Positioning Solution',
    aboutUs:'About us',
    contactUs:'Contact Us',
  },
  dSCircularPackaging:{
    dSCircularPackagingTitle:'Digital Solutions for Circular Packaging',
    doYouHaveTheseTroubles:'Do you face these problems',
    issuesItemtitle1:'High management costs',
    issuesItemtext1:'Employees must manually inventory on-site carriers daily → time-consuming and costly',
    issuesItemtitle2:'Low turnover efficiency',
    issuesItemtext2:'Upstream/downstream data is opaque and unsynchronized → carriers idle for long periods',
    issuesItemtitle3:'High asset loss rate',
    issuesItemtext3:'Lack of full-process lifecycle management → hard to track, leading to high loss',
    issuesItemtitle4:'Low utilization rate',
    issuesItemtext4:'The closed use of vehicles leads to a large number of repeated purchases or over-purchases, and the purchases are not supported by data.',
    issuesItemtitle5:'Black-box management',
    issuesItemtext5:'No real-time info at carrier flow points → increased logistics cost',
    weWillProvideYouWithProfessionalSolutions:'We will provide you with professional solutions',
    digitalSystemForZhituoVehicles:'WEIOT Smart Carrier Digital System',
    solutionsText:'The system combines digital applications and Internet of Things technology to build a smart digital platform based on "standardization + intelligence + Internet" based on circular vehicles, giving the vehicles digital life and making them knowable, visible, manageable and traceable.',
    solutionsText1:'Knowable',
    solutionsText2:'Visible',
    solutionsText3:'Manageable',
    solutionsText4:'Traceable',
    advantageItemTitle1:'Reduce Costs & Increase Efficiency',
    advantageItemText1:'With the data support of WEIOTs Vehicle Digital Platform, repeated purchases and idle resources can be effectively avoided, greatly improving the circulation efficiency of vehicles.',
    advantageItemTitle2:'Logistics Visualization',
    advantageItemText2:'Tracking of logistic vehicles can help build precise visualization of supply chains and upgrade cargo tracking from "following the vehicle" to "following the cargo"',
    advantageItemTitle3:'Automation',
    advantageItemText3:'Enable online and automatic carrier management',
    advantageItemTitle4:'Real-Time Logistics Monitoring',
    advantageItemText4:'Monitor transport in real time with data',
    architectureTitle:'Solution Architecture',
    highlightsTitle:'Core Highlights',
    highlightsText:'Computer and mini-program dual platforms',
    highlightsItemTitle1:'Real-time Asset Tracking',
    highlightsItemText1:'Display current Llocation and Status',
    highlightsItemTitle2:'Transfer Trajectory',
    highlightsItemText2:'Efficiently track Goods and routes  in real time',
    highlightsItemTitle3:'Transfer Trajectory',
    highlightsItemText3:'Transfer Records',
    highlightsItemTitle4:'Site Management',
    highlightsItemText4:'Track Inventory and Movement across Locations',
    highlightsItemTitle5:'Geo-Fences',
    highlightsItemText5:'Set Geo-Fences at Sites/risk Areas, trigger Alarms',
    highlightsItemTitle6:'Alarm Management',
    highlightsItemText6:'Multiple intelligent Alerts for abnormal Events',
    highlightsItemTitle7:'Multi-Tier Customer Management',
    highlightsItemText7:'Handle multiple Clients efficiently',
    highlightsItemTitle8:'Large Screen Display',
    highlightsItemText8:'Visualize Assets and Sites on a Map for Dispatch',
    scenariosTitle:'Application Scenarios',
    scenariosText:'Suitable for reusable packaging in industries such as:',
    scenariosText1:'Unified Management of Boxes and Goods, Recycling, Empowering Smart Supply Chains.',
    scenariosItemLabel1:'Pallet boxes',
    scenariosItemLabel2:'Grid containers',
    scenariosItemLabel3:'Metal turnover boxes',
    scenariosItemLabel4:'Plastic pallets',
    scenariosItemLabel5:'Battery pack racks',
    scenariosItemLabel6:'Panel boxes',
    locatorsTitle:'Relating Trackers',
  },
  product:{
    productTitle:'Product Center',
    productText:'Professionalism and Care for Every Safe Journey',
    reasonsTitle:'Why Choose WEIOT Positioning Products?',
    reasonsText1:'Multiple Positioning Methods',
    reasonsText2:'Cloud Platform Integration',
    reasonsText3:'Privacy and Security',
    reasonsText4:'Professional Support',
  },
  productDetail:{
    productDetailTitle:'Product Details',
    gobackProduct:'Back to Product Center',
    productHighlights:'Product Highlights',
    productParameters:'Product Specifications',
    project:'Project',
    specification:'Specification',
    series:'series',
    locator:'Locator',
    d98Brighttext1:'3+ Years Battery Life',
    d98Brighttext2:'9-Layer Positioning Technology',
    d98Brighttext3:'Custom Reporting Cycles',
    d98Brighttext4:'Smart Alerts for Asset Movement',
    d98Brighttext5:'Anti-Tampering Alerts',
    d98Brighttext6:'IP65 Industrial Design',
    d98ArgumentKey1:'Specification',
    d98ArgumentValue1:'4G CAT1',
    d98ArgumentKey2:'Frequency Band',
    d98ArgumentValue2:'Domestic full Network Access',
    d98ArgumentKey3:'LED Indicators',
    d98ArgumentValue3:'Not supported',
    d98ArgumentKey4:'Positioning Method',
    d98ArgumentValue4:'GPS+WiFi+4G\WiFi+4G',
    d98ArgumentKey5:'GPS Accuracy',
    d98ArgumentValue5:'5m',
    d98ArgumentKey6:'WiFi Accuracy',
    d98ArgumentValue6:'20m',
    d98ArgumentKey7:'LBS Accuracy',
    d98ArgumentValue7:'1km',
    d98ArgumentKey8:'Reporting Interval',
    d98ArgumentValue8:'1 report/day when stationary, 1 report/hour when moving (customizable)',
    d98ArgumentKey9:'Average Operating Current',
    d98ArgumentValue9:'18.8mA',
    d98ArgumentKey10:'Standby Current',
    d98ArgumentValue10:'4μA',
    d98ArgumentKey11:'Battery Voltage',
    d98ArgumentValue11:'3.7V',
    d98ArgumentKey12:'Motion Sensor',
    d98ArgumentValue12:'Supported',
    d98ArgumentKey13:'Battery Capacity',
    d98ArgumentValue13:'Standard: 4400mAh (Optional: 2200mAh)',
    d98ArgumentKey14:'Power Supply',
    d98ArgumentValue14:'Battery-powered',
    d98ArgumentKey15:'Charging',
    d98ArgumentValue15:'Non-rechargeable, non-removable',
    d98ArgumentKey16:'Charging Interface',
    d98ArgumentValue16:'--',
    d98ArgumentKey17:'Battery Life',
    d98ArgumentValue17:'5 years / 2,200 to 10,000 cycles (dual batteries)',
    d98ArgumentKey18:'Material',
    d98ArgumentValue18:'Industrial-grade ABS',
    d98ArgumentKey19:'Protection Rating',
    d98ArgumentValue19:'IP65',
    d98ArgumentKey20:'Size',
    d98ArgumentValue20:'64mm*62mm*19mm',
    d98ArgumentKey21:'Weight',
    d98ArgumentValue21:'76.5g',
    d98ArgumentKey22:'Operating Temperature',
    d98ArgumentValue22:'-20°C~70°C',
    d98ArgumentKey23:'Storage Temperature',
    d98ArgumentValue23:'-40°C~80°C',
    d96Brighttext1:'IP65 industrial grade design, no fear of rain or washing',
    d92ArgumentValue1:'Restart: Short press the power button, the green light flashes twice; after restarting, the green light stays on for 30 seconds if the first data upload is successful, and the green light flashes for 15 seconds if the upload is abnormal',
    d92ArgumentValue2:'Standard：2200mAH（Optional：4400mAH）',
    d92ArgumentValue3:'1100 times in 5 years \\5000 times',
    d82Brighttext1:'Customizable Reporting Frequency',
    d82Brighttext2:'Intelligent Alerts',
    d82Brighttext3:'Asset Binding',
    d82Brighttext4:'IP53 Industrial-grade Design',
    d82ArgumentKey1:'Body color',
    d82ArgumentValue1:'Charging Indicator: Red while charging; Green when fully charged',
    d82ArgumentValue2:'10m',
    d82ArgumentValue3:'10min/time (customizable)',
    d82ArgumentValue4:'0.24mA',
    d82ArgumentValue5:'65uAH',
    d82ArgumentValue6:'Standard: 2000mAH (optional: 3000mAH\\4000mAH)',
    d82ArgumentValue7:'5W（5V，1A）',
    d82ArgumentValue8:'MicroUSB',
    d82ArgumentValue9:'Black',
    d82ArgumentValue10:'IP53',
    d82ArgumentValue11:'76mm*48mm*24.5mm',
    d82ArgumentValue12:'76.7g',
    d60Brighttext1:'Multi-Mode Positioning: higher Precision',
    d60Brighttext2:'Supports Positioning Platform Integration',
    d60Brighttext3:'No Button Required: Auto-start on power-up',
    d60Brighttext4:'Multiple Alarms: Sends Alerts Promptly',
    d60Brighttext5:'Supports ACC Detection: Real-time Vehicle status reporting',
    d60Brighttext6:'Real-time Positioning: Location Info only',
    d60ArgumentKey1:'Working Voltage',
    d60ArgumentKey2:'Working Current',
    d60ArgumentKey3:'Standby Current',
    d60ArgumentKey4:'Ceramic Antenna',
    d60ArgumentKey5:'Communication Network',
    d60ArgumentKey6:'Communication Standard',
    d60ArgumentKey7:'Communication Protocol',
    d60ArgumentValue1:'GPS+Beidou+Base Station+AGPS',
    d60ArgumentValue2:'DC 9-90V',
    d60ArgumentValue3:'20~30mA@12V',
    d60ArgumentValue4:'Less than 1.6mA',
    d60ArgumentValue5:'Built-in GPS/BD dual-mode ceramic antenna',
    d60ArgumentValue6:'LTE',
    d60ArgumentValue7:'FDD:B1\\3\\5\\8 TDD:B34\\38\\39\\40\\41',
    d60ArgumentValue8:'JT808',
    d60ArgumentValue9:'80mm*32.5mm*13mm',
    d60ArgumentValue10:'36.7g',
    d60ArgumentValue11:'-25°C~70°C',
    d60ArgumentValue12:'-25°C~85°C',
    bTArgumentKey1:'Broadcast Cycle',
    bTArgumentKey2:'Fixing Method',
    bTArgumentValue1:'BLE 2.4G',
    bTArgumentValue2:'To be used with D98BT, the beacon broadcasts at 3-second intervals, and the transmission distance in open areas is 25 meters',
    bTArgumentValue3:'1 time per 3 seconds',
    bTArgumentValue4:'6.2uA',
    bTArgumentValue5:'3.0V',
    bTArgumentValue6:'5 Years',
    bTArgumentValue7:'300mAH',
    bTArgumentValue8:'Industrial Grade ABS+PC',
    bTArgumentValue9:'32mm*36mm*10mm',
    bTArgumentValue10:'11.5g',
    bTArgumentValue11:'-20°C~70°C',
    bTArgumentValue12:'-40°C~80°C',
    bTArgumentValue13:'3mm diameter rivets or self-tapping screws',
  },
  dSVehiclePositioning:{
    vehicleTitle:'Vehicle Positioning Solutions',
    issuesItemTitle1:'Difficult to monitor location trajectory',
    issuesItemtext1:`The vehicle's location information, empty status, historical track, and mileage statistics cannot be monitored in real time. When problems arise, it is impossible to trace the problem and optimize the operation process.`,
    issuesItemTitle2:'Difficult to manage fleet',
    issuesItemtext2:'Logistics companies cannot obtain timely, accurate and comprehensive information about transport vehicles. Most management plans are not flexible enough and lack targeted and professional customization.',
    issuesItemTitle3:'Idle rate is too high',
    issuesItemtext3:'The vehicles are not evenly distributed and there are too many idle vehicles. Usually, tasks are allocated manually without a support system, which results in slow coordination and uneven allocation, resulting in a large amount of manpower, maintenance, and various fuel consumption costs.',
    issuesItemTitle4:'Difficult to ensure driving safety',
    issuesItemtext4:`Drivers' bad behaviors such as speeding, fatigue driving, and traffic violations increase safety risks during cargo transportation.`,
    issuesItemTitle5:'Manual coordination is cumbersome',
    issuesItemtext5:'Usually manual coordination and allocation of tasks, no support system, slow coordination and uneven allocation',
    solutionsLabel:'Vehicle positioning system',
    solutionsText:`WEIOT vehicle positioning platform is a comprehensive solution based on modern information technology, integrating advanced technologies such as the Internet of Things, big data, and cloud computing. The positioning product transmits vehicle data to the backend management system in real time through 4G and 5G networks. The platform can understand the vehicle's driving trajectory, speed, stay and other related information in real time, providing strong support for vehicle scheduling, route planning, fault warning, management, etc.`,
    nonParagraphText1:'Real-time Positioning',
    nonParagraphText2:'Track playback',
    nonParagraphText3:'Real-time Warning',
    highlightsTitle:'Core Highlights',
    highlightsText:'Computer and mini-program dual platforms',
    highlightsItemTitle1:'Vehicle Real-time Positioning',
    highlightsItemtext1:'Real-time query of vehicle location and status, effective vehicle monitoring',
    highlightsItemTitle2:'Historical Track',
    highlightsItemtext2:`By selecting the track driving time period, you can view the vehicle's historical driving track and vehicle parking point information`,
    highlightsItemTitle3:'Geo-Fences',
    highlightsItemtext3:'Standardize the management of the designated vehicle operation area, and send out alarm signals when vehicles enter or leave.',
    highlightsItemTitle4:'Abnormal alarm',
    highlightsItemtext4:'Multiple intelligent warnings to send out alarm signals in time: such as speeding, long-term stop, etc.',
    applicationSceneTitle:'Application Scenarios',
    applicationSceneText1:'WEIOT vehicle positioning platform is suitable for',
    applicationSceneText2:'Logistics and transportation, vehicle rental, public transportation, coach vehicles, mechanical vehicles, private cars, two-wheeled vehicles',
    applicationSceneText3:'It can be used in a variety of scenarios, and has broad market prospects and huge application value.',
    sceneItemLabel1:'Scenario 1: Automotive Finance Risk Management',
    sceneItemLabel2:'Scenario 2: Government Official Vehicle Management',
    sceneItemLabel3:'Scenario 3 Vehicle Rental Management',
    sceneItemLabel4:'Scenario 4 Two-wheeler Management',
    sceneItemTitle1:'Vehicle location tracking and loss of connection issues',
    sceneItemText1:'Through the real-time positioning function of WEIOT, the location of the loaned vehicle can be accurately tracked, and timely measures can be taken to recover it and reduce asset losses.',
    sceneItemTitle2:'Improved post-loan management efficiency',
    sceneItemText2:'It can monitor the driving status and position changes of vehicles in real time and detect abnormal behaviors in time, which helps risk control companies to formulate post-loan management strategies more accurately and improve management efficiency.',
    sceneItemTitle3:'Risk Warning and Fraud Identification',
    sceneItemText3:`Smart locator records the vehicle's driving track and historical location information. By analyzing these data, potential fraud can be identified, helping risk control companies to promptly detect and respond to potential risks.`,
    sceneItemTitle4:'Improve collection efficiency and success rate',
    sceneItemText4:'In the event of a default, Smart Locator can help the risk management company quickly locate the defaulting vehicle and provide strong support for debt collection.',
    sceneItemTitle5:'Strengthen vehicle management and security and anti-theft',
    sceneItemText5:'Smart Locator has anti-theft alarm function. When the vehicle moves abnormally or is stolen, it can send alarm information to the manager in time. This helps the manager to take quick measures to ensure the safety of the vehicle.',
    sceneItemTitle6:'Improve vehicle dispatch and utilization efficiency',
    sceneItemText6:'Through Smart Locator, managers can understand the distribution and status of vehicles in real time, so as to dispatch vehicle resources more reasonably. This helps to reduce the idle time of vehicles and improve the efficiency of the use of official vehicles.',
    sceneItemTitle7:'Avoid confusion in vehicle use and unknown whereabouts',
    sceneItemText7:'Irregular use or poor management of official vehicles can easily lead to chaos, such as vehicles being borrowed privately or going to unknown places. Smart Locator can track the location of vehicles in real time, accurately grasp vehicle dynamics, and avoid vehicle abuse.',
    sceneItemTitle8:'Monitoring driving behavior and safety',
    sceneItemText8:'Smart Locator can record the driving track and speed of the vehicle. This helps managers monitor the behavior of drivers, ensure that they abide by traffic regulations, and reduce unsafe behaviors such as speeding and illegal driving.',
    sceneItemTitle9:'Vehicle location tracking and anti-theft',
    sceneItemText9:`During the vehicle rental process, the rental company faces the risk of vehicle theft or illegal transfer. Smart Locator can track the location of the vehicle in real time, ensuring that the rental company can keep track of the vehicle's dynamics at any time.`,
    sceneItemTitle10:`Reduce the risk of rental fraud and overdue repayment`,
    sceneItemText10:`Rental fraud and overdue payment are still common risks in the vehicle rental industry. By installing Smart locators, rental companies can monitor the vehicle's driving track and location changes in real time to ensure that the vehicle is returned on time and reduce the risk of overdue payment.`,
    sceneItemTitle11:`Improve customer experience and service quality`,
    sceneItemText11:'Through Smart Locator, rental companies can provide customers with convenient and efficient services. When customers need a car urgently, rental companies can quickly find available vehicles nearby and provide them to customers, helping customers use rental vehicles more conveniently.',
    sceneItemTitle12:'Monitoring driving behavior and safety',
    sceneItemText12:`During the vehicle rental process, once an accident occurs, Smart Locator can provide the vehicle's driving track and location information, provide strong evidence for accident investigation and responsibility division, handle accident disputes fairly, and safeguard their own rights and interests.`,
    sceneItemTitle13:`Vehicle Anti-theft and Location Tracking`,
    sceneItemText13:'Two-wheeled vehicles have become targets of theft due to their lightness and ease of movement. By installing a Xuyu locator, the owner can track the location of the vehicle in real time. Once the vehicle is stolen or moves abnormally, an alarm will be issued quickly to help the owner find the vehicle in time and reduce the risk of vehicle theft.',
    sceneItemTitle14:'Cycling Safety Monitoring',
    sceneItemText14:`Some riders may violate regulations such as speeding and running red lights, which not only affects traffic order but also poses safety risks. WEIOT GPS can record the vehicle's driving track and speed, provide behavioral feedback to riders or sharing companies, and regulate riding behavior.`,
    sceneItemTitle15:`Precise vehicle management`,
    sceneItemText15:'For electric vehicle rental or sharing companies, managing a large number of vehicles can be challenging. The Smart Locator provides real-time display of vehicle distribution and status, helping companies achieve precise vehicle management.',
    sceneItemTitle16:'Optimize vehicle management and dispatch.',
    sceneItemText16:'For shared two-wheeled electric vehicle operators, the Smart Locator provides real-time vehicle location information, helping operators better allocate and manage vehicle resources, thereby improving vehicle utilization and operational efficiency.',
    locatorsTitle:'Related Locators.'
  }
}